import {useState} from 'react'
import {CardHeader} from '../../../components'
import {CompanyAddressModel, CompanyModel} from '../../models'
import {formatCep} from '../../../utils/formatStrings'
import UpdateCompanyAddressModal from '../../modals/UpdateCompanyAddressModal'

interface Props {
    company: CompanyModel
    address?: CompanyAddressModel
    getData: () => void
}

export default function AddressShowCompanySubpage({company, address, getData}: Props) {
    const [isOpenUpdateModal, setIsOpenUpdateModal] = useState(false)

    return (
        <>
            <div className='card'>
                <CardHeader title='Informações de endereço'>
                    <div className='btn-group'>
                        <button
                            onClick={() => {
                                setIsOpenUpdateModal(true)
                            }}
                            className='btn btn-sm btn-light-info'
                        >
                            <i className='fa fa-edit'></i>
                            {address != null ? 'Atualizar' : 'Adicionar'}
                        </button>
                    </div>
                </CardHeader>
                {address != null ? (
                    <div className='card-body'>
                        <div className='row mb-3'>
                            <div className='col-12'>
                                <label>CEP</label>
                                <h3>{formatCep(address.ds_zipcode)}</h3>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <div className='col-12 col-lg-6'>
                                <label>Logradouro</label>
                                <h3>{address.ds_street}</h3>
                            </div>
                            <div className='col-12 col-lg-3'>
                                <label>Número</label>
                                <h3>{address.ds_number}</h3>
                            </div>
                            <div className='col-12 col-lg-3'>
                                <label>Complemento</label>
                                <h3>{address.ds_complement ?? '-'}</h3>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <div className='col-12 col-lg-6'>
                                <label>Bairro</label>
                                <h3>{address.ds_neighborhood}</h3>
                            </div>
                            <div className='col-12 col-lg-6'>
                                <label>Cidade</label>
                                <h3>
                                    {address.ds_city} - {address.ds_state}
                                </h3>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className='card bg-warning mt-2'>
                        <div className='card-header'>
                            <div className='card-title'>
                                <i className='fas fa-ban fs-1 text-white me-2'></i>
                                <h4 className='text-white'>
                                    Nenhum endereço cadastrado, é necessário cadastrar para receber
                                    NFs da RubyY.
                                </h4>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <UpdateCompanyAddressModal
                isOpen={isOpenUpdateModal}
                onClose={() => setIsOpenUpdateModal(false)}
                onUpdate={() => getData()}
                company={company}
            />
        </>
    )
}
